import {
  PROFILE,
  HISTORIC_APPOINTMENTS,
  APPOINTMENTS,
  ASSISTANTS_DOCTORS_APPOINTMENTS,
  USER_LIST,
  SCHEDULE_REQUESTS,
  VIDEO_CALL_TEST,
  RAPID_APPOINTMENT,
} from '../../utils/urls';

const desktopTabs = (userType) => {
  let options = [
    {
      label: 'SOLICITUDES DE AGENDA',
    },
    {
      label: 'HISTÓRICO DE CONSULTA',
      href: HISTORIC_APPOINTMENTS,
    },
    {
      label: 'MIS CONSULTAS',
      href: APPOINTMENTS,
    },
    {
      label: 'PROBAR VIDEO',
      href: VIDEO_CALL_TEST,
    },
  ];

  if (userType === 'patient') {
    options.unshift({
      label: 'ATENCIÓN INMEDIATA',
      href: RAPID_APPOINTMENT,
    });
  }

  return options;
};

const mobileOptions = [
  {
    label: 'Mis consultas',
    href: APPOINTMENTS,
  },
  {
    label: 'Histórico de consulta',
    href: HISTORIC_APPOINTMENTS,
  },
  {
    label: 'Solicitudes de agenda',
  },
  {
    label: 'Probar video',
    href: VIDEO_CALL_TEST,
  },
];

const mobileOptionsMenuAssistant = [
  {
    label: 'Agendas',
    href: APPOINTMENTS,
  },
  {
    label: 'Lista de consulta',
    href: ASSISTANTS_DOCTORS_APPOINTMENTS,
  },
  {
    label: 'Lista de usuario',
    href: USER_LIST,
  },
  {
    label: 'Lista de doctores',
    href: USER_LIST,
  },
  {
    label: 'Perfil Doctor',
    href: PROFILE,
  },
  {
    label: 'Solicitudes de agenda',
    href: SCHEDULE_REQUESTS,
  },
];

const profileOptions = [
  {
    label: 'Mi perfil',
    href: PROFILE,
  },
];

export {
  desktopTabs,
  mobileOptions,
  profileOptions,
  mobileOptionsMenuAssistant,
};
